import React, { useState } from "react";
import { Link } from "@mui/material";
import { useForm } from "react-hook-form";
import OTPInput from "react-otp-input";
import ActionButton from "../../Common/Components/Button";
import EastIcon from "@mui/icons-material/East";
import FilledAlert from "../../Common/Components/StackAlert";

export default function VerifyOtpPage(props) {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const { handleSubmit } = useForm({});

  const handleVerify = () => {
   
    if (otp !== "" &&otp.length==6) {
      props.handleVerifyOtp(otp);
    } else {
      setError("Please enter OTP");
    }
  };

  const handleChange = (otp) => {
    const numericOtp = otp.replace(/[^0-9]/g, "");
    setError("");
    setOtp(numericOtp);
  };
  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData("text");
    if (pastedData.length === 6 && /^[0-9]+$/.test(pastedData)) {
      setOtp(pastedData);
    }
    e.preventDefault(); // Prevent pasting directly into one input
  };
  

  const handleResendOtp = () => {
    setError("");
    props.handleResendOtp();
  };
  return (
    <div>
      <div>
        {error && (
          <div style={{ padding: "15px 0px" }}>
            <FilledAlert severity="warning" message={error} />
          </div>
        )}

        <div
          style={{
            fontSize: "16px",
            fontWeight: 500,
            color: "#01083A",
            textAlign: "left",
            padding: "10px 0px",
            fontFamily:"Poppins"
          }}
        >
          <br />
          Enter OTP
        </div>

        <div>
          <OTPInput
            value={otp}
            onChange={handleChange}
            numInputs={6}
            separator={<span style={{ width: "8px" }}></span>}
            renderInput={(props) => (
              <input
                {...props}
                onPaste={handlePaste}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                onKeyDown={(e) => {
                  if (
                    !(
                      e.key === "Backspace" ||
                      e.key === "Delete" ||
                      e.key === "ArrowLeft" ||
                      e.key === "ArrowRight" ||
                      e.key === "Tab" ||
                      (e.key >= "0" && e.key <= "9")
                    )
                  ) {
                    // e.preventDefault();
                  }
                }}
                // Attach the paste event here
              />
            )}
            inputStyle={{
              borderRadius: "8px",
              width: "46px",
              height: "44px",
              fontSize: "18px",
              color: "#000",
              fontWeight: "600",
              caretColor: "blue",
            }}
            focusStyle={{
              border: "1px solid #CFD3DB",
              outline: "none",
            }}
            isInputNum={true}
            shouldAutoFocus={true}
            renderSeparator={<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>}
          />
        </div>

        <br />

        <br />
        <div
          style={{
            color: "#0ea5d9",
            cursor: "pointer",
            fontSize: "18px",
            alignSelf: "center",
          }}
          onClick={handleResendOtp}
        >
          <Link style={{ color: "#0ea5d9" }}> Resend OTP</Link>
        </div>
        <div style={{ paddingTop: "10px", textAlign: "end" }}>
          <div>
            <ActionButton
              backgroundColor="rgb(15, 165, 217)"
              color="white"
              //   width="130px"
              buttonText="Verify OTP"
              endIcon={<EastIcon sx={{ marginLeft: "10px" }} />}
              handleSubmit={handleSubmit(handleVerify)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}